if (!customElements.get('whatsapp-order-button')) {
  class WhatsappOrderButton extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      if (!this.link) return;

      const variantsNode = this.querySelector('[data-whatsapp-variants]');
      this.variants = variantsNode ? JSON.parse(variantsNode.textContent) : null;

      this.link.addEventListener('click', () => this.updateLink());
    }

    getSelectedVariantTitle() {
      if (!this.variants) return '';
      const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
      const idInput = form && form.querySelector('input[name="id"]');
      return (idInput && this.variants[idInput.value]) || '';
    }

    getQuantity() {
      const input = document.getElementById(`Quantity-${this.dataset.sectionId}`);
      const quantity = input ? parseInt(input.value, 10) : 1;
      return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
    }

    updateLink() {
      const { number, message, productTitle, productUrl } = this.dataset;
      const variantTitle = this.getSelectedVariantTitle();
      const quantity = this.getQuantity();

      let text = `${message} ${productTitle}`;
      if (variantTitle) text += ` (${variantTitle})`;
      text += ` x ${quantity} - ${productUrl}`;

      this.link.href = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
    }
  }

  customElements.define('whatsapp-order-button', WhatsappOrderButton);
}
